import { AircraftBillingRateType } from './aircraft-billing-rate-type.enum';

export interface AircraftBillingRate {
  $id: string;
  aircraftBillingRateId: number;
  rateType: AircraftBillingRateType;
  rate: number;
  effectiveFromDate?: string;
  effectiveToDate?: string;
}

export const EMPTY_AIRCRAFT_BILLING_RATE: AircraftBillingRate = {
  $id: '',
  aircraftBillingRateId: 0,
  rateType: AircraftBillingRateType.Hour,
  rate: 0
};
